<template>
  <div class="pc-layout__container pc-page-settings">
    <page-header/>
    <!-- <settings-tab/> -->
    <!-- <hr/> -->
    <area-header>账号</area-header>
    <settings-user/>
    <hr/>
    <area-header>数据维护</area-header>
    <settings-data></settings-data>
    <hr/>
    <area-header>关于Peacock</area-header>
    <settings-about/>
    <upload-avatar-dialog/>
  </div>
</template>

<script>
import PageHeader from '@/components/settings/Header.vue'
// import SettingsTab from '@/components/settings/SettingsTab.vue'
import SettingsUser from '@/components/settings/SettingsUser.vue'
import AreaHeader from '@/components/settings/AreaHeader.vue'
import SettingsData from '@/components/settings/SettingsData.vue'
import SettingsAbout from '@/components/settings/SettingsAbout.vue'
import UploadAvatarDialog from '@/components/dialog/UploadAvatarDialog.vue'

export default {
  components: {
    PageHeader,
    // SettingsTab,
    SettingsUser,
    AreaHeader,
    SettingsData,
    SettingsAbout,
    UploadAvatarDialog
  }
}
</script>

<style lang="scss">
@import '@/assets/variables.scss';

.pc-page-settings {
  padding: 2rem 3rem;
  overflow: auto;

  hr {
    border: none;
    border-top: 1px solid $border-color-structure;
    margin: 3rem 0;
  }
}
</style>
